import {alias, createModelSchema, list} from "serializr";
import {BaseObject} from "@/common/BaseObject";
import {Schema} from "@/common/Schema";

export class PermissionsUserModel extends BaseObject {

    constructor() {
        super();
        this._email = "";
        this._uid = "";
        this._permission = [];
    }

    get email() {return this._email;}
    set email(value) {this._email = value;}

    get uid() {return this._uid;}
    set uid(value) {this._uid = value;}

    get permission() {return this._permission;}
    set permission(value) {this._permission = value;}

    copy() {
        return super.copy();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new PermissionsUserModel());
        } else if (target instanceof PermissionsUserModel) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(PermissionsUserModel, {
    _email: alias("email", Schema.primitive()),
    _uid: alias("uid", Schema.primitive()),
    _permission: alias("permission", list(Schema.primitive())),
});